// Languages
export const LOCALES = ['sk', 'en'];

// Price for renting or returning equipement outside work hours in €
export const OUTSIDE_WORK_HOURS_PRICE = 20;
